import awsmobile from '../../aws-exports';
import Auth from '@aws-amplify/auth';
import AWSAppSyncClient, { AUTH_TYPE, AWSAppSyncClientOptions } from 'aws-appsync/lib';

export class AppDataService {
  /**
   * Stores an instance of the AWS AppSync client.
   */
  client: AWSAppSyncClient<any>;

  constructor(options: AWSAppSyncClientOptions, pollInterval: number) {
    try {
      this.client = new AWSAppSyncClient(options);
    } catch (e) {}
  }
}

export const AppDataServiceConfig: AWSAppSyncClientOptions = {
  url: awsmobile.aws_appsync_graphqlEndpoint,
  region: awsmobile.aws_appsync_region,
  auth: {
    type: AUTH_TYPE.AWS_IAM,
    credentials: () => Auth.currentCredentials()
  },
  cacheOptions: {
    addTypename: false
  },
  disableOffline: true,
};

const appDataService = new AppDataService(AppDataServiceConfig, 30000);

export { appDataService };


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/appsync-client/index.ts